import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CommercialAgreement } from './commercial-agreement.interface';
import { CommercialAgreementService } from './commercial-agreement.service';

const service = new CommercialAgreementService();

export interface CommercialAgreementState {
   commercialAgreementOverview?: PaginatedResponse<CommercialAgreement>;
}

const CommercialAgreementStore: Module<CommercialAgreementState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_COMMERCIAL_AGREEMENT_OVERVIEW(state, overview: PaginatedResponse<CommercialAgreement>) {
         return (state.commercialAgreementOverview = overview);
      },
      ADD_COMMERCIAL_AGREEMENT(state, commercialAgreement: CommercialAgreement) {
         state.commercialAgreementOverview?.data.push(commercialAgreement);
      },
      CHANGE_COMMERCIAL_AGREEMENT(state, commercialAgreement: CommercialAgreement) {
         const index = (state.commercialAgreementOverview?.data || []).findIndex((co) => co.id === commercialAgreement.id);
         if (index > -1) {
            state.commercialAgreementOverview?.data.splice(index, 1, {
               ...state.commercialAgreementOverview?.data[index],
               ...commercialAgreement,
            });
         }
      },
      DELETE_COMMERCIAL_AGREEMENT(state, commercialAgreementId: number) {
         const index = (state.commercialAgreementOverview?.data || []).findIndex((co) => co.id === commercialAgreementId);
         if (index > -1) {
            state.commercialAgreementOverview?.data.splice(index, 1);
         }
      },
   },
   actions: {
      async getCommercialAgreements(context: any, query: any) {
         return await service.getCommercialAgreements(query).then((commercialAgreementOverview) => {
            context.commit('SET_COMMERCIAL_AGREEMENT_OVERVIEW', commercialAgreementOverview);
            return commercialAgreementOverview;
         });
      },
      async createCommercialAgreement(context: any, commercialAgreement: any) {
         const commercialAgreementObj = { ...commercialAgreement };
         delete commercialAgreementObj.worker_statutes;
         delete commercialAgreementObj.performance_code;

         if (commercialAgreement.worker_statute_ids || commercialAgreement.worker_type_ids) {
            delete commercialAgreementObj.worker_statute_id;
            delete commercialAgreementObj.worker_type_id;
            return await service.postCommercialAgreementsBatch(commercialAgreementObj);
         }

         delete commercialAgreementObj.worker_statute_ids;
         return await service.postCommercialAgreement(commercialAgreementObj).then((response) => {
            context.commit('ADD_COMMERCIAL_AGREEMENT', response);
            return response;
         });
      },
      async changeCommercialAgreement(context: any, payload: { commercialAgreementId: number; commercialAgreement: CommercialAgreement }) {
         const response = await service.putCommercialAgreement(payload.commercialAgreementId, payload.commercialAgreement);
         context.commit('CHANGE_COMMERCIAL_AGREEMENT', response);
         return response;
      },
      async deleteCommercialAgreement(context: any, commercialAgreementId: number) {
         const response = await service.deleteCommercialAgreement(commercialAgreementId);
         context.commit('DELETE_COMMERCIAL_AGREEMENT', commercialAgreementId);
         return response;
      },
      async getCommercialAgreementsByIds(context: any, data: any) {
         return await service.getCommercialAgreement(data);
      },
      async getOptionalCommercialAgreements(context: any, data: any) {
         return await service.getOptionalCommercialAgreements(data);
      },
      async searchCommercialAgreements(context: any, search: string) {
         return await service.getCommercialAgreements({ search });
      },
   },
};

export default CommercialAgreementStore;
